import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { LastStepperService } from "src/app/services/last-stepper/last-stepper.service";

@Component({
  selector: "app-dashboard-job",
  templateUrl: "./dashboard-job.component.html",
  styleUrls: ["./dashboard-job.component.css"],
})
export class DashboardJobComponent implements OnInit {

  dashboardData: any = {};
  userDetails: any;
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  lastProfileUpdatedDate?: string;
  
	limit = 4;
	skip = 1;
  constructor(public route: ActivatedRoute, private router: Router,
    private api: AdminService, private userDetailsService: UserDetailsService, private lastStepperService: LastStepperService) {

    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDetails = userData;
    });

    this.lastStepperService.lastStepperObserver.subscribe(stepper => {
      if (stepper) {
        this.lastProfileUpdatedDate = stepper.updatedAt;
        this.getDashboardData(stepper.isPreferences);
      }
    });
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
    this.api.setSearch('');
  }

  getDashboardData(isPreferencesCompleted: number) {
    this.api.getData(isPreferencesCompleted == 1 ? apiUrl._dashboardForActiveUser : apiUrl._dashboardForGuestUser, {})
      .subscribe((res) => this.dashboardData = res.data, (err) => { console.log(err.error.message, "error"); });
  }

  onJobSaved(job: any) {
    job.saveStatus = job.saveStatus == 1 ? 0 : 1;
    if (job.saveStatus == 1)
      this.dashboardData.countSaveJob = this.dashboardData?.countSaveJob + 1;
    else {
      this.dashboardData.countSaveJob = this.dashboardData?.countSaveJob - 1;
    }
  }

  openEmployerDetails(employerId) {
    this.router.navigate(["/employer-choice/details/" + employerId + "/about"]);
  }

  profileScore(val: number) {
    if (val != undefined) {
      var c = Math.PI * (9 * 2);
      var pct = ((100 - val) / 100) * c;
      return pct;
    }
    return 56.5487;
  }

  color(val: number) {
    return val == undefined ? '#f1f1f1' : val > 50 ? '#4fb860' : '#eec26a';
  }
}
